import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { JumpMethodsInBrowser, JumpTypeEnum } from '@/lib/jumpPage'
import './AppConfirmModal.scss';
import { isServer } from '@/lib/constant';
import { reportCouponWallGoToUseSuccessRate } from './utils';
import { GoToUseType } from './utils';
import { COUPON_WALL_BID_MC } from '@/track/coupon-wall';

interface AppConfirmModalProps {
  url: string;
  visible: boolean;
  onClose: () => void;
}

// 关闭按钮图片
const CLOSE_ICON_URL = 'https://p0.meituan.net/pepperfe/32ef0f90b75f6c0e2a88068c1506b4233059.png';

// 下载美团App链接
const APP_DOWNLOAD_URL = 'https://dd.meituan.com/mobile/download/v2/group/auto/waputm_seoapp';

const AppConfirmModal: React.FC<AppConfirmModalProps> = ({ visible, onClose, url }) => {
  // 禁止背景滚动（仅客户端）
  useEffect(() => {
    if (isServer || !visible) return;
    
    // 保存原始样式
    const originalStyle = window.getComputedStyle(document.body).overflow;
    // 禁止滚动
    document.body.style.overflow = 'hidden';
    
    return () => {
      // 恢复滚动
      document.body.style.overflow = originalStyle;
    };
  }, [visible]);

  // SSR 时不渲染
  if (isServer || !visible) return null;

  // 处理下载美团App
  const handleDownload = () => {
    JumpMethodsInBrowser.jumpH5({
      jumpLink: APP_DOWNLOAD_URL,
      jumpType: JumpTypeEnum.H5,
      source: 'couponWallDownloadApp',
      onSuccess() {
        // 上报券去使用-成功-跳转
        reportCouponWallGoToUseSuccessRate(true, GoToUseType.DownloadApp);
      },
      onFail() {
        // 上报券去使用-失败-跳转
        reportCouponWallGoToUseSuccessRate(false, GoToUseType.DownloadApp, "jumpFail");
      },
    });
  };

  // 处理打开美团App
  const handleOpenApp = () => {
    JumpMethodsInBrowser.jumpScheme({
      jumpLink: url,
      jumpType: JumpTypeEnum.MT_APP,
      source: 'couponWallOpenApp',
      sourceBid: COUPON_WALL_BID_MC.USE_BUTTON,
      onSuccess() {
        // 上报券去使用-成功-跳转
        reportCouponWallGoToUseSuccessRate(true, GoToUseType.JumpApp);
      },
      onFail() {
        // 上报券去使用-失败-跳转
        reportCouponWallGoToUseSuccessRate(false, GoToUseType.JumpApp, "jumpFail");
      },
    });
  };

  const modalContent = (
    <div className="app-confirm-modal" onClick={onClose}>
      <div className="app-confirm-modal-content" onClick={(e) => e.stopPropagation()}>
        {/* 白色背景区块 */}
        <div className="app-confirm-modal-box">
          <div className="app-confirm-modal-title">请打开美团App继续查看</div>
          <div className="app-confirm-modal-buttons">
            <div className="app-confirm-modal-button app-confirm-modal-button-download" onClick={handleDownload}>
              下载美团App
            </div>
            <div className="app-confirm-modal-button app-confirm-modal-button-open" onClick={handleOpenApp}>
              打开美团App
            </div>
          </div>
        </div>
        {/* 关闭按钮 */}
        <div className="app-confirm-modal-close" onClick={onClose}>
          <img src={CLOSE_ICON_URL} alt="关闭" />
        </div>
      </div>
    </div>
  );

  // 使用 Portal 渲染到 body 下（仅客户端）
  if (typeof document !== 'undefined') {
    return createPortal(modalContent, document.body);
  }
  
  return null;
};

export default AppConfirmModal;

